<template>
    <div class="join_contain">
        <div class="search_form">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="Country">
                    <el-select v-model="country">
                        <el-option label="all" value=""></el-option>
                        <el-option v-for="val in countryList" :key="val.id" :label="val.nameEN" :value="val.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="searchJoinListPage" :loading="joinLoading" class="join_filter">Filter</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="join_table" v-loading="joinLoading">
            <el-table :data="joinListData.data"  stripe ref="table" style="width: 100%">
                <el-table-column prop="applyTime" label="Apply Time（Beijing Time）" align="center"></el-table-column>
                <el-table-column prop="name" label="Name" align="center"
                                 class-name="list_table_column"></el-table-column>
                <el-table-column prop="countryNameEN" label="Country" align="center"
                                 class-name="list_table_column"></el-table-column>
                <el-table-column prop="mobile" label="Contact Number" align="center"></el-table-column>
                <el-table-column prop="email" label="Email" align="center"></el-table-column>
                <el-table-column label="Franchised area (State&City)"
                                 align="center">
                    <template  slot-scope="scope">
                        <div>{{ scope.row.province}},{{ scope.row.city}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="Remarks" align="center"></el-table-column>
            </el-table>
        </div>
        <div class="join_table_page">
            <el-pagination
                ref="pagination"
                layout="prev, pager, next, jumper"
                :total="joinListData.total"
                :page-size="joinListData.pageSize"
                :current-page.sync="joinListData.currentPage"
                @current-change="searchJoinListPage">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import api from '@api/cooperation'
    export default {
        data() {
            return {
                country: '',
                isInitDialog: false,
                options: {},
                countryList: [],
                joinListData: {
                    data: [],
                    total: 0,
                    currentPage: 1,
                    pageSize: 10,
                },
                joinLoading:false
            }
        },
        mounted: function () {
            this.getCountry();
            this.searchJoinListPage();
        },
        methods: {
            getCountry(){
                api.queryAllCountryList({
                    orderField:'nameEn'
                }).then((res)=>{
                    if(res.success){
                        let data = res.data;
                        if(data && data.length>0){
                            this.countryList = data.filter((item)=>item.serviceStatus != 0)
                        }
                    }
                    else{
                        this.$showErrorMessage(res.error.message)
                    }
                })
            },
            searchJoinListPage() {
                this.joinLoading = true;
                api.queryList({
                        pageNo:this.joinListData.currentPage,
                        pageSize:this.joinListData.pageSize,
                        params:{
                            countryId:this.country
                        }
                    }
                ).then((res) => {
                    this.joinLoading = false;
                    if (res.success) {
                        let data = res.data;
                        if(data){
                            this.joinListData.data = data.list ? data.list : [];
                            this.joinListData.total = data.total;
                            this.joinListData.currentPage = data.pageNum;
                            this.joinListData.pageSize = data.pageSize;
                        }
                    }
                    else {
                        if(res.error && res.error.code == 911){
                            this.$router.replace('/login');
                        }else{
                            this.$showErrorMessage(res.message)
                        }
                    }
                }).catch(error => {
                    this.joinLoading = false;
                    this.$showErrorMessage('Service Exceptions！')
                })
            },
            dialogStatus: function (data) {
                this.isInitDialog = data;
            },
        }
    }
</script>
<style scoped>
    .join_contain{
        padding-bottom:20px;
        padding-top:50px;
        margin-left: 250px;
    }
    .join_filter{
        background-color:#FE7B00;
        color: #fff;
        border:none;
    }
    .join_filter:active{
        border: none;
    }

    .join_table_page {
        text-align: right;
        margin-top: 20px;
    }

    .join_table_page li.active {
        color: #fff;
        cursor: default;
        border-color: #1fbcd2;
        background-color: #1fbcd2;
    }
    .join_table_page>>>.el-pager li.active{
        color: #fff;
        background-color: #FE7B00;
        border-radius: 4px;
    }
    .join_table_page>>>.el-pager li.active:hover{
        color: #fff;
    }
    .join_table_page>>>.el-pager li:hover{
        color: #FE7B00;
    }

</style>



// WEBPACK FOOTER //
// src/components/joinList.vue